import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { clientTransactionsRoute } from '../route';

export const clientTransactionsDirectDebitsPageValidateSearchSchema = z.object({
	openedDirectDebit: z.string().optional(),
	pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
});

export const clientTransactionsDirectDebitsRoute = createRoute({
	path: '/direct-debits',
	getParentRoute: () => clientTransactionsRoute,
	component: lazyRouteComponent(
		() => import('./ClientTransactionsDirectDebitsPage'),
		'ClientTransactionsDirectDebitsPage',
	),
	validateSearch: clientTransactionsDirectDebitsPageValidateSearchSchema,
});
